import { Component, Input } from '@angular/core';
import {
  type FormGroupControls,
  FormGroupState,
  NgrxFormsModule,
} from 'ngrx-forms';
import { UsageWizardSMEProps } from '@innogy/become-a-customer/shared/interfaces';
import type { UsageQuestionnaireSME } from '@innogy/become-a-customer/state';
import { CommonModule } from '@angular/common';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { AnalyticsMapPipe, IsInvalidPipe } from '@innogy/utils-deprecated';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  TrackStepDirective,
  TrackValueChangeDirective,
} from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-usage-questionnaire-sme',
  templateUrl: './usage-questionnaire-sme.component.html',
  standalone: true,
  imports: [
    CommonModule,
    CommonUiFormsModule,
    FontAwesomeModule,
    JssModule,
    AutomationIdDirective,
    IsInvalidPipe,
    NgrxFormsModule,
    TrackValueChangeDirective,
    TrackStepDirective,
    AutomationIdDirective,
    AnalyticsMapPipe,
  ],
})
export class UsageQuestionnaireSMEComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true })
  formState!: FormGroupState<UsageQuestionnaireSME.FormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: UsageWizardSMEProps;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() gasHidden = false;

  get formControls(): FormGroupControls<UsageQuestionnaireSME.FormValues> {
    return this.formState.controls;
  }
}
